import React, { useCallback, useEffect } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'
import HookUtils from '@front/volcanion/utils/hooks'

const withContainer = Component => ({
  onFieldClear: parentOnFieldClear,
  onApplicationChange: parentOnApplicationChange,
  searchGSM: parentSearchGSM,
  ...rest
}) => {
  const setFormValues = hooks.useFormChange()
  const [{ isManagingRecord, user_id, hasCompanyAccess, authentication_type }, setFormState] = hooks.useFormState()
  const [
    load_type,
    password,
    companyservice_id,
    companycontract_id,
    calling_number,
    company_id,
    companyuser_id,
    application_id,
    commercial_formula,
    passenger_number,
  ] = hooks.useFieldValues([
    'load_type',
    'user.password',
    'user.companyservice',
    'user.companycontract',
    'user.calling_number',
    'user.company',
    'user.companyuser',
    'user.application',
    'user.commercial_formula',
    'loads.src_phone',
  ])
  const voucher_id = hooks.useFormStateValue('voucher_id')

  const [selectedCompanyusers, searchCompanyuser] = hooks.useModelSearch('companyuser', 'get', {
    search_id: 'menuselector_companyuser',
    populate: ['user.info', 'user.auth', 'user.customerinfo', 'contact'],
    forced_filter: { company: company_id },
    validate_filter: useCallback(() => !!company_id, [company_id]),
    watchers: [company_id],
  })
  const [, searchCompanycontract] = hooks.useModelSearch('companycontract', 'get')
  const [companyservice] = hooks.useModel('companyservice', [companyservice_id], { single: true, populate: ['contact'] })
  const [voucher] = hooks.useModel('voucher', [voucher_id], { single: true, populate: ['companyservice'] })
  const [caller_companyusers, searchCallerCompanyuser] = hooks.useModelSearch('companyuser', 'get', {
    search_id: 'search_caller_companyuser',
    populate: ['companyuser_services', 'user.customerinfo', 'user.info', 'user.auth', 'contact'],
  })

  const caller_companyuser = _.head(caller_companyusers)
  const selectedCompanyuser = _.find(selectedCompanyusers, ['companyuser_id', companyuser_id])
  const guest_booking = !!_.has(caller_companyuser, 'guest_booking') ? caller_companyuser?.guest_booking : undefined
  const self_booking = caller_companyuser?.self_booking
  const booking_level = caller_companyuser?.booking_level

  const setUserInfo = useCallback(Callbacks.setUserInfoHandler(setFormValues, setFormState), [setFormValues, setFormState])

  const onFieldClear = useCallback(Callbacks.onFieldClearHandler(parentOnFieldClear), [parentOnFieldClear])
  const onApplicationChange = useCallback(app_id => parentOnApplicationChange(app_id, setUserInfo), [setUserInfo, parentOnApplicationChange])
  const searchGSM = useCallback(gsm => parentSearchGSM(gsm, setUserInfo, onFieldClear), [setUserInfo, parentSearchGSM, onFieldClear])

  const onSearchCompanyservice = useCallback(
    Callbacks.onSearchCompanyserviceHandler(searchCallerCompanyuser, setFormValues, setFormState, user_id)
    , [searchCallerCompanyuser, setFormValues, setFormState, user_id])
  const onSearchCompanycontract = useCallback(Callbacks.onSearchCompanycontractHandler(searchCompanycontract, setFormValues, setFormState), [searchCompanycontract, setFormValues, setFormState])
  const onSearchCompanyuser = useCallback(Callbacks.onSearchCompanyuserHandler(searchCompanyuser, setFormValues, setFormState), [searchCompanyuser, setFormValues, setFormState])
  const getCompanyuserFilter = useCallback(Callbacks.getCompanyuserFilterHandler(), [])
  const getCompanyuserValidate = useCallback(Callbacks.getCompanyuserValidateHandler(booking_level, self_booking, companyservice_id), [booking_level, self_booking, companyservice_id])
  const handleChangeRidemode = useCallback(() => setFormValues([{ field: 'ridemode_duration', value: undefined }]))

  const require_confirmation = companyservice?.require_confirmation
  const hasPassword = !!companyservice?.password
  const phoneValue = selectedCompanyuser?.user?.auth?.gsm || passenger_number || calling_number || companyservice?.contact?.gsm
  const allowServicePrecision = _.includes(['service', 'direct'], authentication_type)
  const companyuser_watchers = [companyuser_id, company_id, companycontract_id, booking_level, self_booking, companyservice_id, caller_companyuser]

  useEffect(() => {
    !!companyservice && setFormState({ hasCompanyAccess: !companyservice.password || companyservice.password === password })
  }, [HookUtils.getRecordComplete(companyservice), password])

  useEffect(() => {
    !!user_id && !!companyservice_id && searchCallerCompanyuser({ user: user_id, services: [companyservice_id] })
  }, [user_id, companyservice_id])

  useEffect(() => {
    if (!isManagingRecord && !!voucher?.companyservice) {
      setFormValues([
        { field: 'user.companyservice', value: voucher?.companyservice?.companyservice_id },
        { field: 'user.companycontract', value: voucher?.companyservice?.contract },
      ])
    }
  }, [HookUtils.getRecordComplete(voucher)])

  const mergedProps = {
    user: user_id,
    application: application_id,
    service: companyservice_id,
    companyuser_watchers,
    require_confirmation,
    calling_number,
    phoneValue,
    guest_booking,
    isManagingRecord,
    companycontract_id,
    company_id,
    authentication_type,
    hasCompanyAccess,
    hasPassword,
    load_type,
    commercial_formula,
    allowServicePrecision,
    searchGSM,
    onApplicationChange,
    onSearchCompanyuser,
    onSearchCompanycontract,
    onSearchCompanyservice,
    handleChangeRidemode,
    getCompanyuserFilter,
    getCompanyuserValidate
  }

  return (
    <Component {...mergedProps} {...rest} />
  )
}
export default withContainer
